module.exports = __webpack_public_path__ + "img/taxiwhite.57d19a3c.png";